angular.module('gym.privacy_policies').factory('PrivacyPolicies', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('privacy_policies');
}]);
